import { type CoverageKpis } from '@apps/web/features/coverage/model/dashboard_model';
import { cn } from '@apps/web/lib/utils';

export function CoverageKpiStrip({
    kpis,
    unknownOnlyActive,
    onToggleUnknownOnly,
}: {
    readonly kpis: CoverageKpis;
    readonly unknownOnlyActive: boolean;
    readonly onToggleUnknownOnly: () => void;
}) {
    return (
        <div className="text-muted-foreground flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
            <span>
                <span className="text-foreground font-medium">
                    {kpis.shownCount}
                </span>{' '}
                of {kpis.rosterCount} caregivers
            </span>
            <span aria-hidden="true">·</span>
            <button
                type="button"
                onClick={onToggleUnknownOnly}
                aria-pressed={unknownOnlyActive}
                className={cn(
                    'focus-visible:ring-primary rounded underline-offset-2 hover:underline focus-visible:ring-2 focus-visible:outline-none',
                    unknownOnlyActive && 'text-foreground font-medium',
                )}
            >
                <span className="text-foreground font-medium">
                    {kpis.noAvailabilityCount}
                </span>{' '}
                with no availability on file
                {unknownOnlyActive ? ' (showing only these)' : ''}
            </button>
        </div>
    );
}
